import React from 'react'
import * as Styles from './CardVehicleRecommendationV2.styles'

export default function CardVehicleRecommendationV2({ cardId, dataVehicle }) {
  const {
    linkCard,
    linkThumb,
    uniqueId,
    make,
    model,
    price,
    year,
    km,
    city,
    tag,
    description,
  } = dataVehicle

  return (
    <Styles.Card
      href={linkCard}
      id={cardId}
      data-testid={cardId}
      role="article"
      aria-labelledby={`title-${uniqueId}`}
      aria-describedby={`description-${uniqueId} year-${uniqueId} km-${uniqueId} city-${uniqueId}`}
      target='_blank'
    >
      <Styles.Image src={linkThumb} alt={tag.alt} />
      <Styles.Content>
        <Styles.TextWrapper>
          <Styles.Title id={`title-${uniqueId}`}>
            {make} {model}
          </Styles.Title>
          <Styles.Text
            id={`description-${uniqueId}`}
            data-testid="vehicle-description"
          >
            {description}
          </Styles.Text>
        </Styles.TextWrapper>
        <Styles.Price
          data-testid="vehicle-price"
          className={price.length > 20 ? 'price-resize' : 'price'}
        >
          {price}
        </Styles.Price>
        <Styles.DataLabel>
          <Styles.DataValue data-testid="vehicle-year" id={`year-${uniqueId}`}>
            {year}
          </Styles.DataValue>
          <Styles.DataValue data-testid="vehicle-km" id={`km-${uniqueId}`}>
            {km}
          </Styles.DataValue>
        </Styles.DataLabel>
      </Styles.Content>
      <Styles.Footer data-testid="vehicle-city" id={`city-${uniqueId}`}>
        <Styles.Icon src="/assets/img/icon/icon-location.svg" />
        <span>{city}</span>
      </Styles.Footer>
    </Styles.Card>
  )
}
